'use strict';
const goldAsset = require('./gold-asset');
module.exports = function IconLocaliser(imageDownloader, resourceManager) {
	const localiseIcon = (function (icon, options) {
			let iconUrl = icon.url, width = false, height = false;
			const isGoldAsset = iconUrl && goldAsset.isGoldAssetId(iconUrl);

			if (resourceManager) {
				iconUrl = resourceManager.getResource(iconUrl);
			}
			if (!isGoldAsset || !options || !options.sendSignedGoldAsserUrls) {
				if (options && options.imageScale) {
					width = icon.width * options.imageScale;
					height = icon.height * options.imageScale;
				}
				return imageDownloader.convertToPng(iconUrl, width, height)
				.then(dataUri => icon.url = dataUri);
			} else {
				icon.url = iconUrl;
				return Promise.resolve();
			}

		}),
		ensureResources = function () {
			if (resourceManager && resourceManager.resignUrls) {
				return resourceManager.resignUrls();
			}
			return Promise.resolve();
		},
		localiseSingleIcon = function (idea, options) {
			const icon = idea && idea.attr && idea.attr.icon;
			return icon && localiseIcon(icon, options);
		},
		localiseBackgroundImage = async function (idea, options) {
			if (idea?.attr?.themeOverrides?.canvas?.icon) {
				await localiseIcon(idea?.attr?.themeOverrides?.canvas?.icon, options);
			}
			if (idea?.theme?.canvas?.icon) {
				const clone = JSON.parse(JSON.stringify(idea.theme));
				await localiseIcon(clone.canvas.icon, options);
				idea.theme = clone;
			}
		},
		localiseIcons = async function (iconContainer, iconExtractor, options) {
			const remoteIcons = iconExtractor(iconContainer);
			if (remoteIcons && remoteIcons.length > 0) {
				await ensureResources();
				await Promise.all(remoteIcons.map(icon => localiseIcon(icon, options)));
			}
			return iconContainer;

		};
	Object.freeze(Object.assign(this, {localiseSingleIcon, localiseBackgroundImage, localiseIcons}));
};
